module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento19.5411dcb2.svg";